import React from "react";
import MyBadge from "../MyBadge";
import HelpButton from "../../HelpContent/HelpButton";
import ContactsIcon from "../../../assets/icons/contacts_main.svg2";
import AssetIcon from "../../../assets/icons/asset-01.svg2";
import GroupIcon from "../../../assets/icons/groups.svg2";
import CalenderIcon from "../../../assets/icons/calendar.svg2";
import NylasIcon from "../../../assets/icons/nylas.svg2";
import googleIcon from "../../../assets/brand_icons/google.png";
import icloudIcon from "../../../assets/brand_icons/icloud.png";
import microsoftIcon from "../../../assets/brand_icons/microsoft.png";
import exchangeIcon from "../../../assets/brand_icons/exchange.png";
import yahooIcon from "../../../assets/brand_icons/yahoo.png";
import zoomIcon from "../../../assets/brand_icons/zoom.png";
import imapIcon from "../../../assets/brand_icons/imap.png";
import calendarIcon from "../../../assets/brand_icons/calendar.png";
import ThirdPartyIcon from "../../../assets/icons/Icon_Library/application icons/dashboard/icon_3rd_party_api.svg2";
import ApiMessagingIcon from "../../../assets/icons/Icon_Library/application icons/dashboard/icon_message_api.svg2";
import ApiLogicIcon from "../../../assets/icons/Icon_Library/application icons/dashboard/icon_logic_api.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { h } from "vue";

export const apiTypes = [
  {
    name: "nylas",
    heading: "Nylas Calendar Integration with Logic",
    subheading: "Integrate calendar functionality.",
    icon: NylasIcon,
    helpKey: "data-import-nylas-api",
  },
  {
    name: "third-party",
    heading: "3rd Party API",
    subheading: "Connect to your or your partner API.",
    icon: ThirdPartyIcon,
    helpKey: "data-import-third-party-api",
  },
  {
    name: "logic",
    heading: "Logic API",
    subheading: "Start and update logic processes.",
    icon: ApiLogicIcon,
    helpKey: "data-import-logic-api",
  },
  {
    name: "messaging",
    heading: "Messaging API",
    subheading: "Connect to our messaging API.",
    icon: ApiMessagingIcon,
    helpKey: "data-import-messaging-api",
  },
  // {
  //   name: "ldap",
  //   heading: "LDAP",
  //   subheading: "Interact with your contacts server.",
  //   icon: ContactsIcon,
  //   helpKey: "data-import-ldap-api",
  // },
];
export function DropdownButton({ option }) {
  return (
    <div className="">
      <div className="d-flex align-items-center">
        <div className="me-3">
          <option.icon width={50} />
        </div>
        <div className=" d-flex flex-column align-items-start ms-3">
          <h5 className="fw-bold">
            {option.heading} <HelpButton helpKey={option.helpKey} />
        </h5>
          <h6 className="text-secondary">{option.subheading}</h6>
        </div>
      </div>
    </div>
  );
}

export default function ApiType({ api, onChange }) {
  const selectedAPI = apiTypes.find((a) => a.name === api.Kind);
  return (
    <div>
      <div className="my-3">
        <span className="fw-bold">
          <MyBadge count={1} />
        </span>
        <span className="fs-4 fw-bold ms-2">
          What type of API do you want to connect to?
          <HelpButton helpKey="data-import-api-type" />
        </span>
      </div>
      <div className="row">
        <div className="col-lg-4">
          <div
            className="overflow-auto p-3"
            style={{
              //   maxHeight: 300,
              scrollbarColor:
                "var(--color-dark-purple) rgba(var(--color-blue),0.1)",
            }}
          >
            {apiTypes
              .filter((o) => !o.disabled)
              .map((o) => (
                <button
                  type="button"
                  className={`btn p-3 bg-white  mb-2 rounded-4 w-100 text-start border-0 ${
                    api.Kind === o.name ? "opacity-100" : "opacity-50"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    onChange(o.name);
                  }}
                  disabled={
                    o.disabled || api.NylasStatus === "connected" || api.Uuid
                  }
                  style={{
                    ...(api.Kind !== o.name &&
                      api.Uuid && {
                        filter: "grayscale(100%) blur(1px)",
                      }),
                  }}
                >
                  {api.Uuid && api.Kind === o.name && (
                    <FontAwesomeIcon icon={faLock} className="float-end" />
                  )}
                  <DropdownButton option={o} />
                </button>
              ))}
          </div>
        </div>
        <div className="col-1"></div>
        <div className="col">
          {api.NylasStatus === "connected" && (
            <div className="alert alert-warning">
              <strong>Warning:</strong> You have already connected to Nylas. You
              cannot change the API type while connected.
            </div>
          )}

          {!selectedAPI && (
            <div className="text-secondary mt-4">
              <div
                className="d-flex justify-content-center align-items-center mb-5"
                style={{ marginTop: "100px" }}
              >
                <FontAwesomeIcon icon={faExclamationTriangle} size="8x" />
              </div>
              <h1 className="text-center">Please select an API type</h1>
            </div>
          )}

          {["nylas", "nylas-contacts"].includes(api.Kind) && (
            <div className="">
              <div className="mt-4">
                <h5 className="fw-bold">{selectedAPI.heading}</h5>
                <div>
                  Logic uses Nylas to power secure, real‑time calendar
                  connections between our users and their recipients. By
                  connecting their calendar via Nylas, Logic users can:
                </div>
                <ul className="my-1">
                  <li>Share messages that contain a booking link.</li>
                  <li>
                    Allow recipients to schedule appointments directly into the
                    sender’s calendar.
                  </li>
                  <li>
                    Automatically synchronise the booked event into both the
                    sender’s and recipient’s calendars (where supported by the
                    recipient’s provider).
                  </li>
                </ul>
                <div>
                  Nylas sits between Logic and the calendar providers, handling
                  the complexity so Logic can focus on delivering a streamlined
                  user experience.
                </div>
              </div>
              <div className="mt-2">
                <h5 className="fw-bold my-1">What Nylas does for Logic:</h5>
                <ul>
                  <li className="fw-bold">Unified calendar API</li>
                  <li>
                    Connect once and support multiple providers (Google,
                    Microsoft, iCloud, and more) without building separate
                    integrations.
                  </li>
                  <li className="fw-bold">Secure authentication</li>
                  <li>
                    OAuth 2.0 support for secure, token-based authentication
                    with major calendar providers.
                  </li>
                  <li className="fw-bold">Event syncing</li>
                  <li>
                    Keeps Logic in sync with users’ calendars, ensuring
                    availability is accurate when generating booking links and
                    that booked appointments are written back to the correct
                    calendar.
                  </li>
                  <li className="fw-bold">Data normalisation</li>
                  <li>
                    Standardises calendar data across providers so Logic can
                    treat all calendars the same way, regardless of where
                    they’re hosted.
                  </li>
                </ul>
              </div>
              <div>
                <h5 className="fw-bold my-1">
                  Supported providers via Nylas in Logic::
                </h5>
                <ul>
                  <li>
                    <div className="d-flex align-items-center gap-3">
                      <img
                        src={googleIcon}
                        alt="Google Icon"
                        style={{ width: 32 }}
                      />
                      <div>
                        <div className="fw-bold fs-5">Google</div>
                        Connect Google Calendar using OAuth 2.0.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center  mt-4 gap-3">
                      <img
                        src={microsoftIcon}
                        alt="Microsoft Icon"
                        style={{ width: 32 }}
                      />
                      <div>
                        <div className="fw-bold fs-5">Microsoft</div>
                        Connect Microsoft 365 and Outlook calendars using OAuth
                        2.0.
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="d-flex align-items-center mt-4 gap-3">
                      <img
                        src={icloudIcon}
                        alt="iCloud Icon"
                        style={{ width: 32 }}
                      />
                      <div>
                        <div className="fw-bold fs-5">iCloud</div>
                        Connect Apple iCloud calendars.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center  mt-4 gap-3">
                      <img
                        src={exchangeIcon}
                        alt="Exchange Icon"
                        style={{ width: 32 }}
                      />
                      <div>
                        <div className="fw-bold fs-5">Exchange</div>
                        <div>
                          Access Microsoft Exchange server (on-premises)
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center  mt-4 gap-3">
                      <img
                        src={calendarIcon}
                        alt="Virtual Calendar Icon"
                        style={{ width: 32 }}
                      />
                      <div>
                        <div className="fw-bold fs-5"> Virtual Calendar</div>
                        <div>
                          Create and access calendars without connecting to a
                          third-party service provider.
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}

          {api.Kind === "third-party" && (
            <div className="mt-4">
              <h5>Connect to a 3rd Party API</h5>
              <div>
                Integrate with external APIs provided by you or your partners.
                Use this option to connect to custom services, fetch or send
                data, and extend your workflow with additional capabilities.
              </div>
              <ul className="mt-3">
                <li>Supports RESTful and other standard API protocols</li>
                <li>Configure authentication, endpoints, and data mapping</li>
                <li>Ideal for custom integrations and partner solutions</li>
              </ul>
            </div>
          )}
          {api.Kind === "logic" && (
            <div className="mt-4">
              <h5>Logic API</h5>
              <div>
                Use the Logic API to start and update logic processes. This
                allows you to create complex workflows and automate tasks within
                your application.
              </div>
              <ul className="mt-3">
                <li>Trigger logic processes programmatically</li>
                <li>Update and manage logic workflows</li>
                <li>Integrate with other APIs and services</li>
              </ul>
            </div>
          )}
          {api.Kind === "messaging" && (
            <div className="mt-4">
              <h5 className="fw-bold">Boomerang Messaging API</h5>
              <div>
                A RESTful, enterprise-grade API enabling 1-way and 2-way
                messaging across SMS, email and voice channels. It supports
                multi-channel workflows, broadcasts, scheduled sends and replies
                that are correlated to the originating message thread via our
                patented subject threading solution — enabling automated,
                interactive engagement.
              </div>
              <h5 className="fw-bold mt-2">Key capabilities:</h5>
              <ul className="mb-1">
                <li>
                  Send outbound messages (SMS, email, voice) from your system to
                  end-users.
                </li>
                <li>
                  Receive and process inbound replies or interactions,
                  automatically matched to their originating conversation
                  thread.
                </li>
                <li>
                  Support for multi-channel workflows (e.g., email-to-SMS, voice
                  fallback) and scheduled or recurring sends.
                </li>
                <li>
                  Intelligent two-way messaging: full conversational flows tied
                  to a subject, not just a message timestamp.
                </li>
              </ul>
              <div className="mb-1">
                <span className="fw-bold h-5 me-1">Typical use-cases:</span>
                <span>
                  Conversational messaging, alerts, onboarding journeys,
                  reminders, appointment rescheduling, customer engagement,
                  business continuity and incident communications.
                </span>
              </div>
              <div className="mb-1">
                <span className="fw-bold h-5 me-1">Security & compliance:</span>
                <span>
                  ISO 27001 certified and designed for high availability
                  enterprise usage.
                </span>
              </div>{" "}
              <div className="mb-1">
                <span className="fw-bold h-5 me-1">
                  Integration simplicity:
                </span>
                <span>
                  One API to plug into existing applications, CRM or workflow
                  engines — send data, let Boomerang handle the communications,
                  threading and response correlation.
                </span>
              </div>
            </div>
          )}
          {api.Kind === "ldap" && (
            <div className="mt-4">
              <h5>LDAP</h5>
              <div>
                Use the LDAP API to interact with your contacts server. This
                allows you to manage user directories, authenticate users, and
                access contact information.
              </div>
              <ul className="mt-3">
                <li>Manage user directories and groups</li>
                <li>Authenticate users against LDAP servers</li>
                <li>Access and manage contact information</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
